import React from "react";
import { Switch } from "../Switch";

interface IProps {
  onChange: (value: boolean) => Promise<any>;
  checked: boolean;
  isDisabled?: boolean;
}

export const MatchingOptionSwitch: React.FC<IProps> = (props) => {
  const [value, setValue] = React.useState(props.checked);
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    if (value === props.checked) {
      return;
    }
    setValue(props.checked);
  }, [props.checked, value]);

  const handleChange = async (
    e: React.ChangeEvent<HTMLInputElement>,
    newValue: boolean
  ) => {
    setValue(newValue);
    setIsLoading(true);
    await props.onChange(newValue);
    setIsLoading(false);
  };

  return (
    <Switch
      isDisabled={props.isDisabled || isLoading}
      switchProps={{
        checked: value,
        onChange: handleChange,
      }}
    />
  );
};

MatchingOptionSwitch.defaultProps = {
  checked: false,
  isDisabled: false,
};
